import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from '@rocketlane/rocket-router';
import { Suspense, lazy } from 'react';
import { Loading } from 'components/atoms/loading';
import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';
import { NotFound } from '../404';
import { SecureRoute } from '../route-with-permission-check';
import { ROUTE_PATHS } from '../routes-paths';
const NitroClawPage = /*#__PURE__*/ lazy(()=>import('components/pages/nitro-claw').then((m)=>({
            default: m.NitroClawPage
        })));
const NitroClawConversationPage = /*#__PURE__*/ lazy(()=>import('components/pages/nitro-claw').then((m)=>({
            default: m.NitroClawConversationPage
        })));
const NitroClawPlaceholderPage = /*#__PURE__*/ lazy(()=>import('components/pages/nitro-claw/nitro-claw-placeholder-page').then((m)=>({
            default: m.NitroClawPlaceholderPage
        })));
const NitroClawNotificationsPage = /*#__PURE__*/ lazy(()=>import('components/pages/nitro-claw/nitro-claw-notifications-page').then((m)=>({
            default: m.NitroClawNotificationsPage
        })));
const ProjectListV2Page = /*#__PURE__*/ lazy(()=>import('routes/projects/list-v2').then((m)=>({
            default: m.ProjectListV2Page
        })));
function NitroClawFeatureGate({ children }) {
    const [isNitroClawEnabled] = useAccountFeature(AccountFeature.NitroClaw);
    if (!isNitroClawEnabled) {
        return /*#__PURE__*/ _jsx(NotFound, {});
    }
    return children;
}
const withSecureSuspense = (element)=>/*#__PURE__*/ _jsx(SecureRoute, {
        children: /*#__PURE__*/ _jsx(Suspense, {
            fallback: /*#__PURE__*/ _jsx(Loading, {}),
            children: /*#__PURE__*/ _jsx(NitroClawFeatureGate, {
                children: element
            })
        })
    });
const placeholder = (titleKey, titleDefault)=>withSecureSuspense(/*#__PURE__*/ _jsx(NitroClawPlaceholderPage, {
        titleKey: titleKey,
        titleDefault: titleDefault
    }));
const AGENT_BUILDER = `/${ROUTE_PATHS.AGENT_BUILDER}`;
/** Nitro Claw routes (chat, sidebar pages, agent redirects). */ export const nitroClawRoutes = [
    {
        path: `${ROUTE_PATHS.NITRO_CLAW}`,
        element: withSecureSuspense(/*#__PURE__*/ _jsx(NitroClawPage, {}))
    },
    {
        path: `${ROUTE_PATHS.NITRO_CLAW}/for-review`,
        element: placeholder('nitro_claw.sidebar.for_review', 'For Review')
    },
    {
        path: `${ROUTE_PATHS.NITRO_CLAW}/notifications`,
        element: withSecureSuspense(/*#__PURE__*/ _jsx(NitroClawNotificationsPage, {}))
    },
    {
        path: `${ROUTE_PATHS.NITRO_CLAW}/projects`,
        element: withSecureSuspense(/*#__PURE__*/ _jsx(ProjectListV2Page, {}))
    },
    {
        path: `${ROUTE_PATHS.NITRO_CLAW}/meetings`,
        element: placeholder('nitro_claw.sidebar.resources.meetings', 'Meetings')
    },
    {
        path: `${ROUTE_PATHS.NITRO_CLAW}/tasks`,
        element: placeholder('nitro_claw.sidebar.resources.tasks', 'Tasks')
    },
    {
        path: `${ROUTE_PATHS.NITRO_CLAW}/agents/nitro-analysts`,
        element: withSecureSuspense(/*#__PURE__*/ _jsx(Navigate, {
            to: `/${ROUTE_PATHS.AI_ANALYTICS}`,
            replace: true
        }))
    },
    {
        path: `${ROUTE_PATHS.NITRO_CLAW}/agents/migration`,
        element: withSecureSuspense(/*#__PURE__*/ _jsx(Navigate, {
            to: `${AGENT_BUILDER}/migration-agents`,
            replace: true
        }))
    },
    {
        path: `${ROUTE_PATHS.NITRO_CLAW}/agents/workforce`,
        element: withSecureSuspense(/*#__PURE__*/ _jsx(Navigate, {
            to: `${AGENT_BUILDER}/workforce-agents`,
            replace: true
        }))
    },
    {
        path: `${ROUTE_PATHS.NITRO_CLAW}/agents/rm`,
        element: withSecureSuspense(/*#__PURE__*/ _jsx(Navigate, {
            to: "/agents/rm",
            replace: true
        }))
    },
    {
        path: `${ROUTE_PATHS.NITRO_CLAW}/:conversationId`,
        element: withSecureSuspense(/*#__PURE__*/ _jsx(NitroClawConversationPage, {}))
    }
];
